import { io } from 'socket.io-client';
import { UtilService } from 'hay-core-react';
// Cliente de socket para o Dashboard em tempo real (ver especificação 118) — feito à mão em vez
// de usar o pacote sails.io.js vendorizado (assets/dependencies/sails.io.js), que embute
// socket.io-client v2, incompatível com o socket.io@4.8.x do servidor (ver package-lock.json da
// raiz). Reimplementa só o protocolo mínimo de "requisição virtual" do Sails
// (socket.emit(<verbo>, {url, data, headers}, callback), confirmado lendo
// node_modules/sails-hook-sockets/lib/receive-incoming-sails-io-msg.js e on-connect.js) — o
// mesmo mecanismo que o sails.io.js usa por baixo dos panos.
class SocketService {
    // Sem opção `auth` no handshake: a autenticação é feita por requisição (não por conexão),
    // enviando os mesmos headers que ApiService.js já usa (Authorization) mais o `host` (para
    // detectarPublicacao resolver a publicação certa — sails-hook-sockets só usa o host da URL
    // real da requisição, não do handshake, quando ele vem explícito no payload). Isso permite
    // reaproveitar as policies detectarPublicacao/autenticar tal como estão, sem nenhuma
    // alteração nelas.
    //
    // transports: ['websocket'] — o default REAL do sails-hook-sockets (node_modules/
    // sails-hook-sockets/lib/defaults.js) só permite 'websocket', não 'polling' (diferente do
    // default do socket.io puro). Sem isso, o socket.io-client tenta abrir com polling primeiro
    // (comportamento padrão dele) e o servidor rejeita com "Transport unknown" antes de sequer
    // chegar a tentar o upgrade pra websocket. Como config/sockets.js não foi recriado de
    // propósito (ver especificação 118), o cliente precisa já pedir só websocket.
    //
    // query.__sails_io_sdk_version — sails-hook-sockets (lib/parse-sdk-metadata.js) lê essa
    // metadata do HANDSHAKE de conexão (não do payload de cada requisição virtual) pra decidir
    // se o "SDK" do cliente é compatível (exige semver >=0.11.0). Sem ela, assume '0.9.0' e
    // rejeita TODA requisição virtual com erro SAILS:HOOK:SOCKETS:PARSE_VIRTUAL_REQ — ou seja, o
    // socket conecta normalmente, mas `dashboard/subscribe` nunca é aceito e o socket nunca entra
    // na sala (encontrado via `docker logs`, depois de confirmar que o broadcast do backend
    // rodava mas a tela não recebia nada). Versão copiada de assets/dependencies/sails.io.js
    // (mesma que o sails.io.js vendorizado manda), só pra satisfazer o check — não usamos aquele
    // pacote (ver comentário da classe).
    conectar() {
        return io(window.location.origin, {
            transports: ['websocket'],
            query: {
                __sails_io_sdk_version: '1.2.1',
                __sails_io_sdk_platform: 'browser',
                __sails_io_sdk_language: 'javascript',
            },
        });
    }

    headersRequisicao() {
        const auth = UtilService.getLocalStorage('auth');
        return {
            host: window.location.host,
            ...(auth?.token && { authorization: `Bearer ${auth.token}` }),
        };
    }

    requisicaoVirtual(socket, metodo, url, data) {
        return new Promise((resolve) => {
            socket.emit(metodo, { url, data, headers: this.headersRequisicao() }, (jwr) => {
                resolve({ status: jwr?.statusCode, data: jwr?.body });
            });
        });
    }

    subscribeDashboard(socket) {
        return this.requisicaoVirtual(socket, 'get', '/hay/dashboard/subscribe');
    }
}

const instance = new SocketService();
export default instance;
